import { render, staticRenderFns } from "./DemoPage.vue?vue&type=template&id=6f93ad6f&scoped=true&"
import script from "./DemoPage.vue?vue&type=script&lang=js&"
export * from "./DemoPage.vue?vue&type=script&lang=js&"
import style0 from "./DemoPage.vue?vue&type=style&index=0&id=6f93ad6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f93ad6f",
  null
  
)

export default component.exports